const defaultCapabilities = [
    {
        id: 1,
        title: "Earlier Production Value",
        desc: "Prioritize one to three useful pipelines, dashboards, or models for the first release.",
        image: "/assets/datab/item1.png",
        cardBg: "bg-gradient-to-r from-[#FAFBFF] to-[#6376D2]",
    },
    {
        id: 2,
        title: "Governance Built In",
        desc: "Establish access controls, lineage, and operating standards as part of the foundation.",
        image: "/assets/datab/item2.png",
        cardBg: "bg-gradient-to-r from-[#F2F5F8] to-[#667386]",
    },
    {
        id: 3,
        title: "Cost Visibility",
        desc: "Use tagging, budgets, and workload policies to make platform consumption easier to manage.",
        image: "/assets/datab/item3.png",
        cardBg: "bg-gradient-to-r from-[#F0FAFE] to-[#42B7A7]",
    },
    {
        id: 4,
        title: "Confident Handover",
        desc: "Give internal teams practical documentation, runbooks, and knowledge transfer.",
        image: "/assets/datab/item4.png",
        cardBg: "bg-gradient-to-r from-[#F1FAFE] via-[#B7D8F9] to-[#55A2CD]",
    },
];

export const ConsultingCapabilities = ({
    badge = "Designed around business value",
    heading = "What you can expect from a well-planned implementation",
    subheading = "The right platform components for your current priorities, with security, governance, deployment, and cost controls considered as part of the same implementation.",
    capabilities = defaultCapabilities,
}) => {
    return (
        <section className="w-full bg-white pb-[60px] lg:pb-[100px]">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-16">
                    <div className="w-full lg:w-full max-w-[444px] lg:sticky lg:top-32">
                        <span className="block text-[#ED6800] font-graphik text-[14px] md:text-[16px] font-[500] mb-2 sm:mb-3">
                            {badge}
                        </span>
                        <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.18] tracking-[-0.02em] mb-4 sm:mb-6">
                            {heading}
                        </h2>
                        <p className="text-[#49577A] font-graphik text-[14px] md:text-[16px] font-[500] leading-[1.65] max-w-[440px]">
                            {subheading}
                        </p>
                    </div>

                    <div className="w-full lg:w-full max-w-[742px] flex flex-col gap-[14px] sm:gap-[20px]">
                        {capabilities.map((item) => (
                            <div
                                key={item.id}
                                className={`relative overflow-hidden ${item.cardBg} p-[14px] sm:p-[24px] flex flex-col md:flex-row items-center justify-between gap-6 transition-all duration-300 hover:shadow-lg`}
                            >
                                <div className="w-full md:w-full max-w-max flex flex-col justify-center">
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora leading-[1.25] mb-3">
                                        {item.title}
                                    </h3>
                                    <p className="text-[#01386A] font-graphik text-[14px] md:text-[15px] font-[500] leading-[1.6]">
                                        {item.desc}
                                    </p>
                                </div>

                                <div className="w-full md:w-full max-w-[277px] h-[150px] sm:h-[187px] overflow-hidden flex-shrink-0">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConsultingCapabilities;